import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isConfirmed: null,
    user: null,
    userData: null,
    allBlankCards: null,
    myCards: null,
    jwtToken: null,
    oripas: null,
    deliveryHistory: null,
    snackbar: false,
    snackbarText: '',
    ranking: null,
  },
  getters: {
    isConfirmed: state => state.isConfirmed,
    user: state => state.user,
    userData: state => state.userData,
    allBlankCards: state => state.allBlankCards,
    myCards: state => state.myCards,
    deliveryHistory: state => state.deliveryHistory,
    jwtToken: state => state.jwtToken,
    oripas: state => state.oripas,
    ranking: state => state.ranking,
  },
  mutations: {
    setIsConfirmed(state, isConfirmed){
      state.isConfirmed = isConfirmed
    },
    setUser(state, user) {
      state.user = user
    },
    setUserData(state, userData){
      state.userData = userData
    },
    setAllBlankCards(state, allBlankCards){
      state.allBlankCards = allBlankCards
    },
    setMyCards(state, myCards){
      state.myCards = myCards
    },
    setDeliveryHistory(state, deliveryHistory){
      state.deliveryHistory = deliveryHistory
    },
    setJwtToken(state, jwtToken){
      state.jwtToken = jwtToken
    },
    setOripas(state, oripas){
      state.oripas = oripas
    },
    setSnackbar(state,text){
      state.snackbar = true
      state.snackbarText = text
    },
    unsetSnackbar(state){
      state.snackbar = false
      state.snackbarText = ''
    },
    setRanking(state, ranking){
      state.ranking = ranking
    }
  },
  actions: {
    openSnackbar: ({ commit }, text) => {
      commit("setSnackbar", text);
    },
    closeSnackbar: ({ commit }) => {
      commit("unsetSnackbar");
    },
  },
  modules: {
  }
})
